"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.record.id': '记录ID',
    'onboarding.record.progress': '进度',
    'onboarding.record.created': '创建时间',
    'onboarding.record.updated': '最后更新',
    'onboarding.record.view': '查看详情',
    'onboarding.record.continue': '继续',
};
